/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Action_DarkmodeInputs */

const tr_landing_shortcuts_mock_action_darkmode = /** @type {(inputs: Landing_Shortcuts_Mock_Action_DarkmodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koyu mod`)
};

const en_landing_shortcuts_mock_action_darkmode = /** @type {(inputs: Landing_Shortcuts_Mock_Action_DarkmodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark mode`)
};

const de_landing_shortcuts_mock_action_darkmode = /** @type {(inputs: Landing_Shortcuts_Mock_Action_DarkmodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkelmodus`)
};

const ru_landing_shortcuts_mock_action_darkmode = /** @type {(inputs: Landing_Shortcuts_Mock_Action_DarkmodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тёмная тема`)
};

/**
* | output |
* | --- |
* | "Dark mode" |
*
* @param {Landing_Shortcuts_Mock_Action_DarkmodeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_action_darkmode = /** @type {((inputs?: Landing_Shortcuts_Mock_Action_DarkmodeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Action_DarkmodeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_action_darkmode(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_action_darkmode(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_action_darkmode(inputs)
	return tr_landing_shortcuts_mock_action_darkmode(inputs)
});